import {
    NIPT_PROFESSIONALS_SELECT,
    NIPT_PROFESSIONALS_REMOVE_SELECT,
    NIPT_PROFESSIONALS_SHORT_LIST_TOGGLE,
    NIPT_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST,
    NIPT_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE,
    NIPT_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE
  } from "../../actions/types";
  
  const initialState = {
     selectedItems: [],
     isSelectActive: false,
     isSaving: false,
     error: false,
     msg: ''
  };
  
  const setSelect = (state, action) => {
      let { selectedItems } = action.payload;
      selectedItems  = selectedItems || [];
      let newItems = [...state.selectedItems, ...selectedItems];
      newItems = [... new Set([...newItems])];
      return {
          ...state,
          selectedItems: newItems
      }
  }
  
  const removeItem = (state, action) => {
    let { expertId } = action.payload;
  
    let newItems = [ ...state.selectedItems].filter(l => l !== expertId);
    newItems = [... new Set([...newItems])];
    return {
        ...state,
        selectedItems: newItems
    }
  }

const toggleActive = (state, action) => {
    return {
      ...state,
      isSelectActive: action.payload.isSelectActive,
      selectedItems: []
    }
}

const saveRequest = (state, action) => {
   return {
     ...state,
     isSaving: true,
     error: false,
     msg: ''
   }
}

const removeResponse = (state, action) =>{
  return {
    ...state,
  }
}

const saveResponse = (state, action) => {
  return {
    ...state,
    isSaving: false,
    error: action.payload.error || false,
    msg: action.payload.msg || '',
    selectedItems: [],
    isSelectActive: false
  }
}
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case NIPT_PROFESSIONALS_SELECT:
        return setSelect(state, action);
        break;
      
      case NIPT_PROFESSIONALS_REMOVE_SELECT:
        return removeItem(state, action);
  
      case NIPT_PROFESSIONALS_SHORT_LIST_TOGGLE:
        return toggleActive(state, action);
      
      case  NIPT_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST:
        return saveRequest(state, action);

      case NIPT_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE:
        return saveResponse(state, action);

      case NIPT_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE:
        return removeResponse(state, action);

      default:
        return state;
        break;
    }

  };
  